export const GET_FEEDBACK_REQUEST = 'GET_FEEDBACK_REQUEST'
export const GET_FEEDBACK_SUCCESS = 'GET_FEEDBACK_SUCCESS'
export const GET_FEEDBACK_FAILURE = 'GET_FEEDBACK_FAILURE'

export const EDIT_FEEDBACK_REQUEST = 'EDIT_FEEDBACK_REQUEST'
export const EDIT_FEEDBACK_SUCCESS = 'EDIT_FEEDBACK_SUCCESS'
export const EDIT_FEEDBACK_FAILURE = 'EDIT_FEEDBACK_FAILURE'